const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SyncTableStateQuery: any = {
    GetSyncTableStates: `${Backofficebff}/v1/studio-sync-table-state/list`,
};
